import {style} from '@vanilla-extract/css'

export const virtualList = style({
  position: 'relative',
})

export const virtualListItem = style({
  position: 'absolute',
  left: 0,
  right: 0,
})
